import {Close} from '@mui/icons-material';
import {Box, Button, Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material';
import {useState} from 'react';
import {QueueJobContent} from '../../__generated__/resolvers-types';
import JobList from './JobList';
import HelpButtonWrapper from '../helpButton/HelpButtonWrapper';
import {HelpTutorialEnum} from '../../variables/helpTutorial';

export interface JobListButtonProps {
  content: QueueJobContent;
  buttonText?: string;
}

export function JobListButton({content, buttonText = 'Show Job List'}: JobListButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <HelpButtonWrapper helpTutorialEnum={HelpTutorialEnum.SHOW_JOB_LIST}>
      <>
        <Button variant="outlined" onClick={() => setOpen(!open)} sx={{width: '100%'}}>
          {buttonText}
        </Button>
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="md"
          fullWidth
          slotProps={{
            paper: {
              sx: {
                minHeight: '80vh',
                maxHeight: '80vh',
                p: 2,
              },
            },
          }}
        >
          <DialogTitle>
            Job List
            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box sx={{flex: 1, minHeight: 0, maxHeight: '100%', overflowY: 'scroll'}}>
              <JobList content={content} />
            </Box>
          </DialogContent>
        </Dialog>
      </>
    </HelpButtonWrapper>
  );
}
